/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_Feature_3Inputs */

const en_pricing_tier_free_feature_3 = /** @type {(inputs: Pricing_Tier_Free_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited to 1.2x speed`)
};

const es_pricing_tier_free_feature_3 = /** @type {(inputs: Pricing_Tier_Free_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitado a velocidad 1.2x`)
};

/**
* | output |
* | --- |
* | "Limited to 1.2x speed" |
*
* @param {Pricing_Tier_Free_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_feature_3 = /** @type {((inputs?: Pricing_Tier_Free_Feature_3Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_Feature_3Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_feature_3(inputs)
	return en_pricing_tier_free_feature_3(inputs)
});